import { Container, Spinner } from "react-bootstrap";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { usePage } from "../../hooks/usePage";
import { usePrecargaEvents } from "../../hooks/usePrecargaEvents";
import EditPrecargaEventForm from "./EditPrecargaEventForm";

export default function PrecargasEdit() {
  usePage({ title: "Precargas" });

  const { eventid } = useParams();
  const navigate = useNavigate();
  const cashlessEventId = eventid ? parseInt(eventid) : null;

  const { precargaEvent, isLoadingPrecargaEvent, hasPrecargaEvent } =
    usePrecargaEvents({
      cashlessEventId,
    });

  if (isLoadingPrecargaEvent) {
    return (
      <Container fluid>
        <div className="text-center p-5">
          <Spinner animation="border" />
          <p className="mt-3">Cargando configuración de precarga...</p>
        </div>
      </Container>
    );
  }

  if (!eventid) {
    return null;
  }

  if (!hasPrecargaEvent) {
    return <Navigate to={`/${eventid}/preloads/create`} replace />;
  }

  return (
    <Container fluid>
      <EditPrecargaEventForm
        eventId={precargaEvent.id}
        onSuccess={() => navigate(`/${eventid}/preloads/detail`)}
        onCancel={() => navigate(`/${eventid}/preloads/detail`)}
      />
    </Container>
  );
}
